import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DIC } from '../dic';
import * as moment from 'moment';
import { GN } from '../../gn';

/**
 * Generated class for the CalendarPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-calendar',
  templateUrl: 'calendar.html',
})
export class CalendarPage {

  calMode = 'days'
  selMonth=''
  selDay:any
  Days = []
  StartDay = 1  // 1 - Monday, 0 - Sunday 
  SelectedDay: any
  DayTitles = []
  MonthsTitle = []
  SelectedDayTitle = ''
  SelectedMonthTitle = ''
  SelectedYearTitle = ''
  _SelectedMonth = 1
  _SelectedYear = 1
  _Years = []
  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN) {
    this.selDay = this.navParams.get('d')
    if(this.selDay == undefined){
      this.selDay = new Date()
    }
    this.MonthsTitle = [ dic.l['January'], dic.l['February'], dic.l['March'], dic.l['April'], dic.l['May'], dic.l['June'], dic.l['July'], dic.l['August'], dic.l['September'], dic.l['October'], dic.l['November'], dic.l['December']]  
    if (this.StartDay==0){
      this.DayTitles = [this.dic.l["Sun"], this.dic.l["Mon"], this.dic.l["Tue"], this.dic.l["Wed"], this.dic.l["Thu"], this.dic.l["Fri"], this.dic.l["Sat"]]
    }else{
      this.DayTitles = [this.dic.l["Mon"], this.dic.l["Tue"], this.dic.l["Wed"], this.dic.l["Thu"], this.dic.l["Fri"], this.dic.l["Sat"], this.dic.l["Sun"]]
    }
    
    this.selMonth  = moment(this.selDay).format('YYYY-MM')
    this.Days = this.getMonthDyas(this.selMonth)
    
    this.SelectedDay = moment(this.selDay).format('YYYY-MM-DD')
    
    
    this.SelectedDayTitle = this.MonthsTitle[parseInt(moment(this.selDay).format('M'))-1] + ', '+   moment(this.selDay).format('YYYY')
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad CalendarPage');    
    // console.log()
  }
  changeModeToYear(){
    var y = parseInt(moment(this.selDay).format('YYYY'))
    this._SelectedYear = y
    this._Years = [y-7, y-6, y-5, y-4, y-3, y-2, y-1, y, y+1, y+2, y+3, y + 4, y+5, y+6, y + 7]
    this.calMode = 'years'
    this.SelectedYearTitle = this._Years[0]+' - '+this._Years[14]
  }
  nextYear(){
    for (var i=0; i<this._Years.length; i++){
      this._Years[i] = this._Years[i]+15
    }
    this.SelectedYearTitle = this._Years[0]+' - '+this._Years[14]
  }
  prevYear(){
    for (var i=0; i<this._Years.length; i++){
      this._Years[i] = this._Years[i]-15
    }
    this.SelectedYearTitle = this._Years[0]+' - '+this._Years[14]
  }
  changeModeToMonth(){
    this.calMode = 'months'
    this._SelectedMonth = parseInt(moment(this.selDay).format('M'))-1
    this.SelectedMonthTitle= moment(this.selDay).format('YYYY')
  }
  backModeToDays(){
    this.calMode = 'days'
  }
  backModeToMonth(){
    this.calMode = 'months'
  }
  chooseMonth(idx){
    var mnt = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
    this.selDay = moment(moment(this.selDay).format('YYYY')+'-'+mnt[idx]+'-01').toDate()
    this.selMonth  = moment(this.selDay).format('YYYY-MM')
    this.Days = this.getMonthDyas(this.selMonth)    
    this.SelectedDay = moment(this.selDay).format('YYYY-MM-DD')    
    this.SelectedDayTitle = this.MonthsTitle[parseInt(moment(this.selDay).format('M'))-1] + ', '+   moment(this.selDay).format('YYYY')
    this.backModeToDays()
  }
  
  chooseYear(idx){
    this.selDay = moment(this._Years[idx]+'-'+moment(this.selDay).format('MM')+'-01').toDate()
    // this.selDay = moment(moment(this.selDay).format('YYYY')+'-'+mnt[idx]+'-01').toDate()
    this.selMonth  = moment(this.selDay).format('YYYY-MM')
    this.Days = this.getMonthDyas(this.selMonth)    
    this.SelectedDay = moment(this.selDay).format('YYYY-MM-DD')    
    this.SelectedDayTitle = this.MonthsTitle[parseInt(moment(this.selDay).format('M'))-1] + ', '+   moment(this.selDay).format('YYYY')
    this.calMode = 'months'
    this._SelectedMonth = parseInt(moment(this.selDay).format('M'))-1
    this.SelectedMonthTitle= moment(this.selDay).format('YYYY')
  }

  prevMonth(){
    var d = this.selMonth+'-01'
    this.selMonth = moment(d).add(-1,'months').format('YYYY-MM')
    this.Days = this.getMonthDyas(this.selMonth)
    d = this.selMonth+'-01'
    this.SelectedDayTitle = this.MonthsTitle[parseInt(moment(d).format('M'))-1] + ', '+   moment(d).format('YYYY')
  }
  nextMonth(){
    var d = this.selMonth+'-01'
    this.selMonth = moment(d).add(1,'months').format('YYYY-MM')
    this.Days = this.getMonthDyas(this.selMonth)
    d = this.selMonth+'-01'
    this.SelectedDayTitle = this.MonthsTitle[parseInt(moment(d).format('M'))-1] + ', '+   moment(d).format('YYYY')
  }
  getMonthDyas(_month) {
    if (_month == null) {
      var dd = new Date()
      var godina = dd.getFullYear()
      var mesec = (dd.getMonth() + 1).toString()
      if (mesec.length == 1) { mesec = '0' + mesec }
      // mesec = (mesec < 9 ? '0' + mesec : mesec)
      _month = godina + '-' + mesec
    }
    // console.log(_month)
    var days = []
    var _m = _month.split("-")
    var dateObject = new Date(parseInt(_m[0]), parseInt(_m[1]) - 1, 1)
    var wd1 = dateObject.getDay()
    var wdPlus = 0;

    if (this.StartDay == 0) {
      wdPlus = wd1
    } else {
      wd1 = wd1 - 1
      if (wd1 == -1) { wd1 = 6 }
      wdPlus = wd1

    }
    var prevMonth = new Date(parseInt(_m[0]), parseInt(_m[1]) - 2, 1)
    var totaldaysPM = new Date(parseInt(_m[0]), parseInt(_m[1]) - 1, 0).getDate();


    for (var i = totaldaysPM - wdPlus + 1; i <= totaldaysPM; i++) {
      var _mon = prevMonth.getMonth() + 1
      var _year = prevMonth.getFullYear()
      var dt = new Date(parseInt(_m[0]), parseInt(_m[1]) - 2, i)
      var wd = dt.getDay()
      var ii = (i <= 9 ? '0' + i : i)
      var mmmm = (_mon <= 9 ? '0' + _mon : _mon)

      days.push({ day: i, weekday: wd, value: _year + '-' + mmmm + '-' + ii, month: 'P', today: false })
    }


    var Deneska = this.getDate()
    var totaldays = new Date(parseInt(_m[0]), parseInt(_m[1]), 0).getDate();
    for (var i = 1; i <= totaldays; i++) {
      var dt = new Date(parseInt(_m[0]), parseInt(_m[1]) - 1, i)
      var wd = dt.getDay()
      var ii = (i <= 9 ? '0' + i : i)
      var Den = _month + '-' + ii
      var _today = false

      // console.log(_month, _mon)
      if (Den == Deneska) { _today = true }
      days.push({ day: i, weekday: wd, value: _month + '-' + ii, month: 'C', today: _today })
    }

    var nextMonth = new Date(parseInt(_m[0]), parseInt(_m[1]), 1)
    var nMCount = 42 - days.length

    for (var i = 1; i <= nMCount; i++) {
      var _mon = nextMonth.getMonth() + 1
      var _year = nextMonth.getFullYear()
      var dt = new Date(parseInt(_m[0]), parseInt(_m[1]), i)
      var wd = dt.getDay()
      var ii = (i <= 9 ? '0' + i : i)
      var mmmm = (_mon <= 9 ? '0' + _mon : _mon)
      days.push({ day: i, weekday: wd, value: _year + '-' + mmmm + '-' + ii, month: 'N', today: false })
    }
    // console.log(days)
    return days
  }

  getDate() {
    var dateObject = new Date()
    var d = dateObject.getDate() + ''; if (d.length == 1) { d = '0' + d }
    var m2 = (dateObject.getMonth() + 1) + ''; if (m2.length == 1) { m2 = '0' + m2 }
    var y = dateObject.getFullYear() + ''; if (y.length == 1) { y = '0' + y }
    return y + '-' + m2 + '-' + d
  }

  selectDen(_den){
    // console.log(_den)
    var cb = this.navParams.get('cb');
    cb(moment(_den).toDate());
    this.navCtrl.pop()
  }
}



// WEBPACK FOOTER //
// ./src/pages/calendar/calendar.ts